"use client";

import { privacyChoice, usePrivacyChoice } from "@/lib/privacy-preferences";
import { Analytics } from "@vercel/analytics/next";

export function SiteAnalytics() {
  const choice = usePrivacyChoice();
  if (choice !== "accepted") return null;
  return <Analytics beforeSend={(event) => {
    if (privacyChoice() !== "accepted") return null;
    const url = new URL(event.url);
    if (/^\/(auth|confirm|reset-password|unsubscribe)(\/|$)/.test(url.pathname)) return null;
    url.search = "";
    url.hash = "";
    return {...event,url:url.toString()};
  }} />;
}
